/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-01-18 20:18:20
 * @FilePath: /vise/packages/app-share/src/store/index.ts
 */
import { InjectionKey } from 'vue';
import {
  createStore as baseCreateStore,
  useStore as baseUseStore,
  Store,
} from 'vuex';
import mutations from './mutations';
import type { State } from './state';
import state from './state';
import MutationTypes from './mutation-types';

type MyStore = Store<State>;
const key: InjectionKey<MyStore> = Symbol();

function useStore() {
  return baseUseStore(key);
}

function createStore() {
  return baseCreateStore<State>({
    state,
    mutations,
  });
}

export {
  key,
  MyStore,
  useStore,
  createStore,
  MutationTypes,
};
